import classNames from "classnames";
import React from "react";

import styles from "../FormField.module.scss";

export interface ICadastralFormField {
  id?: string;
  error?: string;
  name?: string;
  readOnly?: boolean;
  registerField?: any;
  isFocused?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  checksPresenceName?: (
    e: React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLElement>,
    name: string,
  ) => void;
}

export const CadastralFormField: React.FC<ICadastralFormField> = ({
  id,
  error,
  name,
  readOnly = false,
  registerField,
  isFocused,
  onFocus,
  onBlur,
  checksPresenceName,
  autoComplete,
}) => {
  const PATTERN = /\D/g;

  const getInputCadastralValue = (value: string) => {
    return value.replace(PATTERN, "");
  };

  const handleCadastralInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (checksPresenceName) {
      checksPresenceName(e, name);
    }
    const input = e.target;
    let inputCadastralValue = getInputCadastralValue(input.value);
    if (inputCadastralValue.length >= 3) {
      const arrayValue = inputCadastralValue.split("");
      arrayValue.splice(2, 0, ":");
      inputCadastralValue = arrayValue.join("").replaceAll("::", ":");
    }
    if (inputCadastralValue.length >= 6) {
      const arrayValue = inputCadastralValue.split("");
      arrayValue.splice(5, 0, ":");
      inputCadastralValue = arrayValue.join("").replaceAll("::", ":");
    }
    if (inputCadastralValue.length >= 14) {
      const arrayValue = inputCadastralValue.split("");
      arrayValue.splice(13, 0, ":");
      inputCadastralValue = arrayValue.join("").replaceAll("::", ":");
    }
    input.value = inputCadastralValue;
  };

  const handleCadastralKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement;
    if (
      e.key === "Backspace" &&
      getInputCadastralValue(input.value).length === 1
    ) {
      input.value = "";
    }
    return input;
  };

  const handleCadastralPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData ?? window["clipboardData"];
    const input = e.target as HTMLInputElement;
    const inputNumbersValue = getInputCadastralValue(input.value);
    if (pasted) {
      const pastedText = pasted.getData("Text");
      if (PATTERN.test(pastedText)) {
        input.value = inputNumbersValue;
      }
    }
  };

  return (
    <input
      {...registerField}
      id={id}
      className={classNames(styles.input, {
        [styles.error]: error,
        [styles.active]: isFocused,
      })}
      name={name}
      type="text"
      readOnly={readOnly}
      maxLength={19}
      onInput={handleCadastralInput}
      onKeyDown={handleCadastralKeyDown}
      onPaste={handleCadastralPaste}
      onFocus={(e) => {
        onFocus(e);
      }}
      onBlur={(e) => {
        onBlur(e);
      }}
      autoComplete={autoComplete}
    />
  );
};
